export const portalThemeSettingType = {
	Page: 'page',
	Styling: 'styling',
	Playback: 'playback',
	Header: 'header',
	Content: 'content',
	Footer: 'footer',
};

export const portalThemeSettingTypeOrder = {
	styling: 1,
	playback: 2,
	header: 3,
	content: 4,
	footer: 5,
};

export const themeSettingUsingStylingObject = ['header', 'content', 'footer'];

export const stylingKeys = [
	'backgroundColor',
	'gridBackgroundColor',
	'textColor',
	'videoFrameColor',
	'buttonColor',
	'buttonTextColor',
	'menuBackgroundColor',
	'headerShowLogoType',
	'headerShowTitle',
	'headerShowSearch',
	'headerShowNavigationMenu',
	'contentPlaylistCustomize',
	'contentHeroVideoCustomize',
	'footerShowCallToAction',
	'footerShowSocials',
	'footerSimple',
];

export const pageSettingKeys = ['defaultPageLanguage', 'showFavicon'];

export const contentPlaylistCustomizeSubKeys = [
	'contentPlaylistDisplay',
	'contentPlaylistRows',
	'contentPlaylistShowTitle',
];

export const playlistDisplayTypes = [
	{
		key: 'grid',
		label: 'Grid',
	},
	{
		key: 'expandableGrid',
		label: 'Expandable Grid',
	},
	{
		key: 'carousel',
		label: 'Carousel',
	},
	{
		key: 'storyCarousel',
	label: 'Story Carousel',
	},
];

export const playlistTitleTypes = [
	{
		key: 'normal',
		label: 'Default',
	},
	{
		key: 'highlighted',
		label: 'Highlighted',
	},
];

export const searchFilterDisplayTypes = [
	{
		key: 'grid',
		label: 'Grid',
	},
	{
		key: 'carousel',
		label: 'Carousel',
	},
	{
		key: 'storyCarousel',
		label: 'Story Carousel',
	},
];

export const searchFilterTitleTypes = [
	{
		key: 'normal',
		label: 'Default',
	},
	{
		key: 'highlighted',
		label: 'Highlighted',
	},
];

export const fontFamilyOptions = [
	{
		key: '',
		label: 'Default',
	},
	{
		key: 'Roboto',
		label: 'Roboto',
	},
	{
		key: 'Bai Jamjuree',
		label: 'Bai Jamjuree',
	},
];

export const contentHeroVideoCustomizeSubKeys = [
	'contentHeroVideoShowTextBox',
	'contentHeroHeader',
	'contentHeroDescription',
];

export const level2Keys = ['contentHeroHeader', 'contentHeroDescription'];

export const footerShowCallToActionSubKeys = [
	'footerCallToActionHeadline',
	'footerCallToActionDescription',
	'footerCallToActionActionUrl',
];

export const footerShowSocialsSubKeys = [
	'footerSocialUrlLinkedIn',
	'footerSocialUrlFacebook',
	'footerSocialUrlInstagram',
	'footerSocialUrlX',
];

export const stylingKeysNeedToBeHex = [
	'backgroundColor',
	'gridBackgroundColor',
	'textColor',
	'videoFrameColor',
	'buttonColor',
	'buttonTextColor',
	'menuBackgroundColor',
	'menuTextColor',
	'headerBackgroundColor',
	'headerTextColor',
	'heroBackgroundColor',
	'heroTextColor',
	'playlistBackgroundColor',
	'playlistHoverColor',
	'playlistTextColor',
	'playlistButtonColor',
	'playlistButtonTextColor',
	'callToActionBackgroundColor',
	'callToActionTextColor',
	'callToActionButtonColor',
	'callToActionButtonTextColor',
	'footerSocialBackgroundColor',
	'footerSocialTextColor',
	'footerSimpleBackgroundColor',
	'footerSimpleTextColor',
];

export const playerKeys = ['defaultPlayerPreset', 'initiatePlayerOn', 'initiatePlayerOnMobile'];

export const PLAYBACK_INITIATE_PLAYER_ON_GRID_VIEW = 'gridView';
export const PLAYBACK_INITIATE_PLAYER_ON_MEDIA_VIEW = 'mediaView';
export const PLAYBACK_INITIATE_PLAYER_ON_SOFT_BOX = 'softBox';
export const PLAYBACK_INITIATE_PLAYER_ON = [
	PLAYBACK_INITIATE_PLAYER_ON_GRID_VIEW,
	PLAYBACK_INITIATE_PLAYER_ON_MEDIA_VIEW,
	PLAYBACK_INITIATE_PLAYER_ON_SOFT_BOX,
];

export const stylingObjects = ['general', 'header', 'navMenu', 'hero', 'playlist', 'callToAction', 'footerSocial', 'footerSimple'];

export const stylingObjectKeys = {
	general: ['fontFamily', 'backgroundColor'],
	header: ['headerBackgroundColor', 'headerTextColor'],
	navMenu: ['menuBackgroundColor', 'menuTextColor'],
	hero: ['heroBackgroundColor', 'heroTextColor'],
	playlist: [
		'playlistBackgroundColor',
		'playlistHoverColor',
		'playlistTextColor',
		'playlistButtonColor',
		'playlistButtonTextColor',
	],
	callToAction: [
		'callToActionBackgroundColor',
		'callToActionTextColor',
		'callToActionButtonColor',
		'callToActionButtonTextColor',
	],
	footerSocial: ['footerSocialBackgroundColor', 'footerSocialTextColor'],
	footerSimple: ['footerSimpleBackgroundColor', 'footerSimpleTextColor'],
};

export const defaultStylingObject = {
	menuTextColor: '#000000',
	headerTextColor: '#000000',
	heroTextColor: '#000000',
	playlistTextColor: '#000000',
	callToActionTextColor: '#000000',
	callToActionButtonTextColor: '#ffffff',
	playlistButtonTextColor: '#ffffff',
	playlistHoverColor: '#ffffff',
	playlistButtonColor: '#136cfc',
	callToActionButtonColor: '#136cfc',
	backgroundColor: 'transparent',
	headerBackgroundColor: 'transparent',
	heroBackgroundColor: 'transparent',
	playlistBackgroundColor: 'transparent',
	footerSocialBackgroundColor: 'transparent',
	callToActionBackgroundColor: '#fdfdfd',
	menuBackgroundColor: '#fdfdfd',
	footerSimpleBackgroundColor: 'transparent',
	footerSimpleTextColor: '#000000',
};

export const defaultHeaderObject = {
	headerShowLogoType: true,
	headerShowTitle: true,
	headerShowSearch: true,
	headerShowNavigationMenu: true,
};

export const defaultPageObject = {
	showFavicon: true,
	defaultPageLanguage: 'en',
};

export const translationKeys = {
	general: 'SETTINGS_PORTAL_PRESET_GENERAL',
	navMenu: 'SETTINGS_PORTAL_PRESET_NAVIGATION_MENU',
	menuBackgroundColor: 'SETTINGS_PORTAL_PRESET_BG_COLOR',
	menuTextColor: 'SETTINGS_PORTAL_PRESET_TEXT_COLOR',
	headerBackgroundColor: 'SETTINGS_PORTAL_PRESET_BG_COLOR',
	headerTextColor: 'SETTINGS_PORTAL_PRESET_TEXT_COLOR',
	hero: 'SETTINGS_PORTAL_PRESET_HERO',
	heroBackgroundColor: 'SETTINGS_PORTAL_PRESET_BG_COLOR',
	heroTextColor: 'SETTINGS_PORTAL_PRESET_TEXT_COLOR',
	playlist: 'SETTINGS_PORTAL_PRESET_PLAYLIST',
	playlistBackgroundColor: 'SETTINGS_PORTAL_PRESET_BG_COLOR',
	playlistTextColor: 'SETTINGS_PORTAL_PRESET_TEXT_COLOR',
	playlistHoverColor: 'SETTINGS_PORTAL_PRESET_HOVER_COLOR',
	playlistButtonColor: 'SETTINGS_PORTAL_PRESET_BUTTON_COLOR',
	playlistButtonTextColor: 'SETTINGS_PORTAL_PRESET_BUTTON_TEXT_COLOR',
	callToAction: 'SETTINGS_PORTAL_PRESET_CALL_TO_ACTION',
	callToActionBackgroundColor: 'SETTINGS_PORTAL_PRESET_BG_COLOR',
	callToActionTextColor: 'SETTINGS_PORTAL_PRESET_TEXT_COLOR',
	callToActionButtonColor: 'SETTINGS_PORTAL_PRESET_BUTTON_COLOR',
	callToActionButtonTextColor: 'SETTINGS_PORTAL_PRESET_BUTTON_TEXT_COLOR',
	footerSocial: 'SETTINGS_PORTAL_PRESET_FOOTER_SHOW_SOCIALS',
	footerSocialBackgroundColor: 'SETTINGS_PORTAL_PRESET_BG_COLOR',
	footerSocialTextColor: 'SETTINGS_PORTAL_PRESET_TEXT_COLOR',
	footerSimple: 'SETTINGS_PORTAL_PRESET_FOOTER_SIMPLE',
	footerSimpleBackgroundColor: 'SETTINGS_PORTAL_PRESET_BG_COLOR',
	footerSimpleTextColor: 'SETTINGS_PORTAL_PRESET_TEXT_COLOR',
	footerSimpleContent: 'SETTINGS_PORTAL_PRESET_FOOTER_SIMPLE_CONTENT',
	styling: 'SETTINGS_PORTAL_PRESET_STYLING',
	playback: 'SETTINGS_PORTAL_PRESET_PLAYBACK',
	header: 'SETTINGS_PORTAL_PRESET_HEADER',
	content: 'SETTINGS_PORTAL_PRESET_CONTENT',
	footer: 'SETTINGS_PORTAL_PRESET_FOOTER',
	page: 'SETTINGS_PORTAL_PRESET_PAGE',
	logoType: 'SETTINGS_PORTAL_PRESET_LOGOTYPE',
	fontFamily: 'SETTINGS_PORTAL_PRESET_FONT_FAMILY',
	backgroundColor: 'SETTINGS_PORTAL_PRESET_BG_COLOR',
	hoverColor: 'SETTINGS_PORTAL_PRESET_HOVER_COLOR',
	gridBackgroundColor: 'SETTINGS_PORTAL_PRESET_GRID_BG_COLOR',
	defaultPlayerPreset: 'SETTINGS_PORTAL_PRESET_DEFAULT_PLAYER_PRESET',
	textColor: 'SETTINGS_PORTAL_PRESET_TEXT_COLOR',
	videoFrameColor: 'SETTINGS_PORTAL_PRESET_VIDEO_FRAME_COLOR',
	buttonColor: 'SETTINGS_PORTAL_PRESET_BUTTON_COLOR',
	buttonTextColor: 'SETTINGS_PORTAL_PRESET_BUTTON_TEXT_COLOR',
	initiatePlayerOn: 'SETTINGS_PORTAL_PRESET_INITIATE_PLAYER_ON',
	initiatePlayerOnMobile: 'SETTINGS_PORTAL_PRESET_INITIATE_PLAYER_ON_MOBILE',
	gridView: 'SETTINGS_PORTAL_PRESET_GRID_VIEW',
	mediaView: 'SETTINGS_PORTAL_PRESET_MEDIA_VIEW',
	softBox: 'SETTINGS_PORTAL_PRESET_SOFTBOX',
	headerShowLogoType: 'SETTINGS_PORTAL_PRESET_HEADER_SHOW_LOGO_TYPE',
	headerShowTitle: 'SETTINGS_PORTAL_PRESET_HEADER_SHOW_TITLE',
	headerShowSearch: 'SETTINGS_PORTAL_PRESET_HEADER_SHOW_SEARCH',
	headerShowNavigationMenu: 'SETTINGS_PORTAL_PRESET_HEADER_SHOW_NAVIGATION_MENU',
	contentPlaylistCustomize: 'SETTINGS_PORTAL_PRESET_CONTENT_PLAYLIST_CUSTOMIZE',
	contentPlaylistDisplay: 'SETTINGS_PORTAL_PRESET_CONTENT_PLAYLIST_DISPLAY',
	contentPlaylistRows: 'SETTINGS_PORTAL_PRESET_CONTENT_PLAYLIST_ROWS',
	contentPlaylistShowTitle: 'SETTINGS_PORTAL_PRESET_CONTENT_PLAYLIST_SHOW_TITLE',
	contentHeroVideoCustomize: 'SETTINGS_PORTAL_PRESET_CONTENT_HERO_VIDEO_CUSTOMIZE',
	contentHeroVideoShowTextBox: 'SETTINGS_PORTAL_PRESET_CONTENT_HERO_VIDEO_SHOW_TEXT_BOX',
	contentHeroHeader: 'SETTINGS_PORTAL_PRESET_CONTENT_HERO_HEADER',
	contentHeroDescription: 'SETTINGS_PORTAL_PRESET_CONTENT_HERO_DESCRIPTION',
	footerShowCallToAction: 'SETTINGS_PORTAL_PRESET_FOOTER_SHOW_CALL_TO_ACTION',
	footerCallToActionHeadline: 'SETTINGS_PORTAL_PRESET_FOOTER_CALL_TO_ACTION_HEADLINE',
	footerCallToActionDescription: 'SETTINGS_PORTAL_PRESET_FOOTER_CALL_TO_ACTION_DESCRIPTION',
	footerCallToActionActionUrl: 'SETTINGS_PORTAL_PRESET_FOOTER_CALL_TO_ACTION_ACTION_URL',
	footerShowSocials: 'SETTINGS_PORTAL_PRESET_FOOTER_SHOW_SOCIALS',
	footerSocialUrlLinkedIn: 'SETTINGS_PORTAL_PRESET_FOOTER_SOCIAL_URL_LINKEDIN',
	footerSocialUrlFacebook: 'SETTINGS_PORTAL_PRESET_FOOTER_SOCIAL_URL_FACEBOOK',
	footerSocialUrlInstagram: 'SETTINGS_PORTAL_PRESET_FOOTER_SOCIAL_URL_INSTAGRAM',
	footerSocialUrlX: 'SETTINGS_PORTAL_PRESET_FOOTER_SOCIAL_URL_X',
	showFavicon: 'SETTINGS_PORTAL_PRESET_SHOW_FAVICON',
	showFaviconPlaceHolder: 'SETTINGS_PORTAL_PRESET_SHOW_FAVICON_PLACEHOLDER',
	defaultPageLanguage: 'SETTINGS_PORTAL_PRESET_DEFAULT_PAGE_LANGUAGE',
};

// qbrick-portal-2.0 also have the same if you change here, you need to change there as well
export const INDIVIDUAL_SHARE_PORTAL_ID = 'q6e2m03b';
